<template>
	<svg :class="iconHolderClass">
		<use :xlink:href="`#${iconId}`"></use>
	</svg>
</template>

<script>
export default {
	name: 'LogoSVGIcon',
	description: 'This required to use svg icon sprite file. With CSS class it can control the icon size.',
	props: {
		iconHolderClass: {
			type: String,
			default: '',
			note: 'CSS class that can be assign to handle size and other',
		},
		iconId: {
			type: String,
			required: true,
			default: '',
			note: 'Required to assign exist ID to get the image from sprite file.',
		},
	},
};
</script>
